/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckApplyTravelDocumentResponseError } from './PaxCheckApplyTravelDocumentResponseError';
import {
    PaxCheckApplyTravelDocumentResponseErrorFromJSON,
    PaxCheckApplyTravelDocumentResponseErrorFromJSONTyped,
    PaxCheckApplyTravelDocumentResponseErrorToJSON,
    PaxCheckApplyTravelDocumentResponseErrorToJSONTyped,
} from './PaxCheckApplyTravelDocumentResponseError';
import type { PaxCheckApplyTravelDocumentResult } from './PaxCheckApplyTravelDocumentResult';
import {
    PaxCheckApplyTravelDocumentResultFromJSON,
    PaxCheckApplyTravelDocumentResultFromJSONTyped,
    PaxCheckApplyTravelDocumentResultToJSON,
    PaxCheckApplyTravelDocumentResultToJSONTyped,
} from './PaxCheckApplyTravelDocumentResult';

/**
 * 
 * @export
 * @interface PaxCheckApplyTravelDocumentResponse
 */
export interface PaxCheckApplyTravelDocumentResponse {
    /**
     * 
     * @type {PaxCheckApplyTravelDocumentResult}
     * @memberof PaxCheckApplyTravelDocumentResponse
     */
    data?: PaxCheckApplyTravelDocumentResult;
    /**
     * 
     * @type {PaxCheckApplyTravelDocumentResponseError}
     * @memberof PaxCheckApplyTravelDocumentResponse
     */
    error?: PaxCheckApplyTravelDocumentResponseError;
}

/**
 * Check if a given object implements the PaxCheckApplyTravelDocumentResponse interface.
 */
export function instanceOfPaxCheckApplyTravelDocumentResponse(value: object): value is PaxCheckApplyTravelDocumentResponse {
    return true;
}

export function PaxCheckApplyTravelDocumentResponseFromJSON(json: any): PaxCheckApplyTravelDocumentResponse {
    return PaxCheckApplyTravelDocumentResponseFromJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckApplyTravelDocumentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckApplyTravelDocumentResultFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckApplyTravelDocumentResponseErrorFromJSON(json['error']),
    };
}

export function PaxCheckApplyTravelDocumentResponseToJSON(json: any): PaxCheckApplyTravelDocumentResponse {
    return PaxCheckApplyTravelDocumentResponseToJSONTyped(json, false);
}

export function PaxCheckApplyTravelDocumentResponseToJSONTyped(value?: PaxCheckApplyTravelDocumentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckApplyTravelDocumentResultToJSON(value['data']),
        'error': PaxCheckApplyTravelDocumentResponseErrorToJSON(value['error']),
    };
}

